import {ItemFactory} from "../items/ItemFactory";
import {IItemSearchResponse} from "../items/interface/Item.interface";
import {IQueryData} from "../items/ItemSearchQuery";

export class ProductListRequestHandler {
  public static async fetchProductList(shopId: number, query?: IQueryData): Promise<IItemSearchResponse> {
    return await ItemFactory.getItems(shopId, query ?? {});
  }
}
